import { forwardRef, type ReactNode } from 'react'

import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

export interface BillingCurrencyInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'type'> {
  onChange?: (value: number) => void
}

export const BillingCurrencyInput = forwardRef<HTMLInputElement, BillingCurrencyInputProps>(
  ({ className, onChange, ...props }, ref): ReactNode => (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">$</span>
      <Input
        ref={ref}
        type="number"
        className={cn('pl-7', className)}
        {...props}
        onChange={(e) => onChange?.(e.target.valueAsNumber || 0)}
      />
    </div>
  )
)

BillingCurrencyInput.displayName = 'BillingCurrencyInput'
